import { DMSIDS } from "models";
import { AutolineConfigSection, ICarConfigSection, IncadeaConfigSection, KeyloopConfigSection } from "modules/DMSv3/Settings/components/AddEditLocationModal/components";

const dmsLocationConfigurable = [
  DMSIDS.INCADEA,
  DMSIDS.INCADEA_API,
  DMSIDS.AUTOLINE,
  DMSIDS.AUTOLINE_EF_NEFKENS,
  DMSIDS.AUTOLINE_OPEL_MENU,
  DMSIDS.KEYLOOP_MENUS,
  DMSIDS.KEYLOOP_MENUS_STAGING,
  DMSIDS.KEYLOOP_JOBS,
  DMSIDS.KEYLOOP_JOBS_STAGING,
  DMSIDS.ICAR_WO,
  DMSIDS.ICAR_PLANNING
];

export const doesLocationDmsConfigExists = (dmsId?: DMSIDS) => (dmsId ? dmsLocationConfigurable.includes(dmsId) : false);

type DmsConfigSectionProps = {
  index: number;
  dmsId?: DMSIDS;
};

export const DmsConfigSection = ({ dmsId, index }: DmsConfigSectionProps) => {
  switch (dmsId) {
    case DMSIDS.KEYLOOP_MENUS:
    case DMSIDS.KEYLOOP_MENUS_STAGING:
    case DMSIDS.KEYLOOP_JOBS:
    case DMSIDS.KEYLOOP_JOBS_STAGING:
      return <KeyloopConfigSection index={index} />;

    case DMSIDS.INCADEA:
    case DMSIDS.INCADEA_API:
      return <IncadeaConfigSection index={index} />;

    case DMSIDS.AUTOLINE:
    case DMSIDS.AUTOLINE_EF_NEFKENS:
    case DMSIDS.AUTOLINE_OPEL_MENU:
      return <AutolineConfigSection index={index} />;

    case DMSIDS.ICAR_WO:
    case DMSIDS.ICAR_PLANNING:
      return <ICarConfigSection index={index} />;

    default:
      return null;
  }
};
